import { render } from "./PatientFindingForm.vue?vue&type=template&id=9203ae72"
import script from "./PatientFindingForm.vue?vue&type=script&lang=js"
export * from "./PatientFindingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__